import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges
} from '@angular/core';


export class SkyPagingComponent implements OnChanges {
  
  public pageSize: number = 10;

  
  public maxPages: number = 5;

  
  public currentPage: number = 1;

  
  public itemCount: number = 0;

  
  public pagingLabel: string;

  
  public currentPageChange: EventEmitter<number> = new EventEmitter<number>();

  public displayedPages: Array<number> = [];
  public pageCount: number = 0;

  public ngOnChanges(changes: SimpleChanges) {
    this.setPage(this.currentPage);
  }

  public setPage(pageNumber: number): void {
    let previousPage = this.currentPage;

    this.setPageCount();

    if (pageNumber < 1 || this.pageCount < 1) {
      this.currentPage = 1;
    } else if (pageNumber > this.pageCount) {
      this.currentPage = this.pageCount;
    } else {
      this.currentPage = pageNumber;
    }

    this.setDisplayedPages();

    if (previousPage !== this.currentPage) {
      this.currentPageChange.emit(this.currentPage);
    }

  }

  public nextPage(): void {
    this.setPage(this.currentPage + 1);
  }

  public previousPage(): void {
    this.setPage(this.currentPage - 1);
  }

  private getDisplayedPageNumbers(
    pageCount: number,
    maxDisplayedPages: number,
    pageNumber: number
  ): Array<number> {
    let pageBounds = Math.floor((maxDisplayedPages - 1) / 2);
    let lowerBound = pageNumber - pageBounds - 1;
    let upperBound = pageNumber + pageBounds - 1;

    if (pageCount < maxDisplayedPages) {
      lowerBound = 0;
      upperBound = pageCount - 1;
    } else {
      if (upperBound > pageCount - 1) {
        upperBound = pageCount - 1;
        /* istanbul ignore else */
        /* sanity check */
        if (upperBound - lowerBound < maxDisplayedPages) {
          lowerBound = upperBound - maxDisplayedPages + 1;
        }
      } else if (lowerBound < 0) {
        lowerBound = 0;
        upperBound = maxDisplayedPages - 1;
      }
    }

    let displayedPageNumbers: Array<number> = [];
    for (let i = lowerBound; i <= upperBound; i++) {
      displayedPageNumbers.push(i + 1);
    }
    return displayedPageNumbers;
  }

  private setPageCount() {
    if (this.itemCount === 0 || this.pageSize === 0) {
      this.pageCount = 0;
      return;
    }

    this.pageCount = Math.ceil(this.itemCount / this.pageSize);

  }

  private setDisplayedPages() {

    this.displayedPages =
      this.getDisplayedPageNumbers(this.pageCount, this.maxPages, this.currentPage);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-paging',
  template: `<ul
  role="navigation"
  *ngIf="pageCount > 1"
  [attr.aria-label]="pagingLabel || 'paging_label' | skyResources"
  >
  <li>
    <a
      href
      (click)="previousPage(); false"
      class="fa fa-caret-left sky-paging-caret"
      sky-cmp-id="previous"
      [ngClass]="{ 'sky-paging-disabled': currentPage === 1 }"
      [attr.aria-label]="'paging_previous' | skyResources"></a>
  </li>
  <li
    *ngFor="let pageNumber of displayedPages"
    class="sky-list-paging-link">
    <a
      href
      [attr.sky-cmp-id]="pageNumber"
      (click)="setPage(pageNumber); false"
      [ngClass]="{ 'sky-paging-current': currentPage === pageNumber }"
      >{{pageNumber}}
    </a>
  </li>
  <li>
    <a
      href
      (click)="nextPage(); false"
      class="fa fa-caret-right sky-paging-caret"
      sky-cmp-id="next"
      [ngClass]="{ 'sky-paging-disabled': pageCount === currentPage }"
      [attr.aria-label]="'paging_next' | skyResources"
      >
    </a>
  </li>
</ul>
`,
  styles: [`:host {
  display: block;
  margin-top: 15px;
}

:host ul {
  margin: 0;
  display: inline-block;
  padding-left: 0;
  border-radius: 4px;
}

:host li {
  display: inline;
}

:host li a {
  background-color: #ffffff;
  color: inherit;
  border-top: 1px solid #e2e3e4;
  border-right: 1px solid #e2e3e4;
  border-bottom: 1px solid #e2e3e4;
  border-left: 1px solid #e2e3e4;
  float: left;
  margin-left: -1px;
  padding: 4px 10px;
  text-decoration: none;
  line-height: 1.42857;
  font-size: 15px;
  cursor: pointer;
}

:host li a.sky-paging-caret {
  padding-left: 8.5px;
  padding-right: 8.5px;
  transform: none;
}

:host li a.sky-paging-current {
  background-color: #eeeeef;
}

:host li a:hover {
  background-color: #d4d4d6;
}

:host li a.sky-paging-disabled {
  color: #686c73;
  cursor: not-allowed;
  pointer-events: none;
}
`],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'pageSize': [{ type: Input },],
'maxPages': [{ type: Input },],
'currentPage': [{ type: Input },],
'itemCount': [{ type: Input },],
'pagingLabel': [{ type: Input },],
'currentPageChange': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
